/* ==========================================================================
   Minerva Candle Co. — Custom JavaScript
   Global interactions and enhancements for the Minerva brand experience.
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     Smooth scroll for anchor links
     -------------------------------------------------------------------------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#' || targetId === '#root') return;
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* --------------------------------------------------------------------------
     Product card hover — subtle lift via shadow
     -------------------------------------------------------------------------- */
  document.querySelectorAll('.product-card, .wt-card').forEach(function (card) {
    card.style.transition = 'box-shadow 300ms cubic-bezier(0.25, 0, 0.3, 1)';
  });

  /* --------------------------------------------------------------------------
     Variant description switcher
     Works on product pages AND quick-buy drawer by watching for URL changes
     and DOM mutations (quick-buy loads content dynamically).
     -------------------------------------------------------------------------- */
  function showVariantDesc(id) {
    document.querySelectorAll('[data-variant-desc]').forEach(function (el) {
      el.style.display = el.dataset.variantDesc == String(id) ? 'block' : 'none';
    });
  }

  function checkVariantFromURL() {
    var p = new URLSearchParams(window.location.search);
    var v = p.get('variant');
    if (v) showVariantDesc(v);
  }

  /* Watch URL changes (product page variant selection) */
  checkVariantFromURL();

  var origReplace = history.replaceState;
  history.replaceState = function () {
    origReplace.apply(this, arguments);
    checkVariantFromURL();
  };

  var origPush = history.pushState;
  history.pushState = function () {
    origPush.apply(this, arguments);
    checkVariantFromURL();
  };

  window.addEventListener('popstate', checkVariantFromURL);

  /* Watch for quick-buy drawer content loading (DOM mutation) */
  var quickBuyWrapper = document.querySelector('.wt__quick-buy--wrapper');
  if (quickBuyWrapper) {
    var observer = new MutationObserver(function () {
      /* When quick-buy loads new product content, attach variant listener */
      var variantDescs = quickBuyWrapper.querySelectorAll('[data-variant-desc]');
      if (variantDescs.length === 0) return;

      /* Listen for variant radio/select changes inside quick-buy */
      quickBuyWrapper.addEventListener('change', function (e) {
        if (!e.target.closest('variant-radios, variant-selects, .product-form__input')) return;
        /* Small delay to let Wonder update the variant */
        setTimeout(function () {
          /* Try to get variant ID from the form's hidden input */
          var hiddenInput = quickBuyWrapper.querySelector('input[name="id"]');
          if (hiddenInput && hiddenInput.value) {
            showVariantDesc(hiddenInput.value);
          }
        }, 150);
      });
    });

    observer.observe(quickBuyWrapper, { childList: true, subtree: true });
  }

})();
